import React from 'react';
import { ArticleLayout } from '../../components/ArticleLayout';

export const MultilingualExcelArticle: React.FC = () => {
    return (
        <ArticleLayout
            title="Mastering Multilingual Excel Files"
            subtitle="Strategies for managing complex spreadsheets with multiple target languages."
        >
            <h3>The Multilingual Matrix</h3>
            <p>
                A common format for software localization is a "matrix" Excel file: Key in Column A, English in Column B,
                French in Column C, Spanish in Column D, and so on. Managing this manually is a nightmare.
            </p>

            <h3>The Split-and-Merge Strategy</h3>
            <p>
                The most efficient way to handle this is to split the file by language.
                Our tool allows you to map Column B as source and Column C as the target for French.
                You can generate a specific XLIFF for the French translator. Simultaneously, map Column B to Column D for the Spanish translator.
            </p>

            <h3>Reassembly</h3>
            <p>
                Once the translators return their XLIFF files, you don't need to copy-paste them back into the respective columns.
                Simply upload the original Excel and all the XLIFF files. Our system intelligently matches the target language
                in the XLIFF to the correct column in your Excel sheet, populating the entire matrix in seconds.
            </p>
        </ArticleLayout>
    );
};
